import React, { useState } from "react";
import { useCheckAccess } from "../../utils/Utilities"; // your access hook
import { queryFamiliesCount } from "../../service/FamilyQueryApi"; // implement this API call
import "../general/General.css";
import { Loading } from "../../components/shared";

const FamilyCountByKootam = () => {
  useCheckAccess("SuperUser");

  const [kootamCounts, setKootamCounts] = useState({});
  const [customGroupCounts, setCustomGroupCounts] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchCounts = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await queryFamiliesCount(); // call your GET /family-counts
      if (response) {
        setKootamCounts(response.kootamCounts || {});
        setCustomGroupCounts(response.customGroupCounts || {});
      } else {
        setError("No data found");
      }
    } catch (err) {
      console.error("Error fetching counts:", err);
      setError(err.message || "Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="general_parent">
      <div className="general_container">
        <div className="general_body">
          <h1>குடும்பங்கள் எண்ணிக்கை</h1>
          <br />
          {loading ? (
            <Loading />
          ) : error ? (
            <div style={{ color: "red" }}>{error}</div>
          ) : (


            <div className="table-container">
              <h3>கூட்டம் வாரியாக</h3>
              <table className="table">
                <thead>
                  <tr>
                    <th>கூட்டம்</th>
                    <th>எண்ணிக்கை</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(kootamCounts).map(([kootam, count]) => (
                    <tr key={kootam}>
                      <td>{kootam}</td>
                      <td>{count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <h3 style={{ marginTop: "2rem" }}>
                பிற குடும்பங்கள்
              </h3>
              <table className="table">
                <thead>
                  <tr>
                    <th>பிற</th>
                    <th>எண்ணிக்கை</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(customGroupCounts).map(([group, count]) => (
                    <tr key={group}>
                      <td>{group}</td>
                      <td>{count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <br />
          <button onClick={fetchCounts} disabled={loading}>
            {loading ? "ஏற்றுகிறது..." : "மறுபடியும் ஏற்று"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FamilyCountByKootam;
